module.exports = __webpack_public_path__ + "static/media/give-classes.156102ee.svg";